import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

type ResolvePasAccessParams = {
  flagEnabled: boolean;
  isChecking: boolean;
  hasPermission: boolean;
};

export const resolvePasAccess = ({
  flagEnabled,
  isChecking,
  hasPermission,
}: ResolvePasAccessParams): AccessDecision => {
  if (!flagEnabled) return 'deny';
  if (isChecking) return 'loading';
  if (!hasPermission) return 'deny';
  return 'allow';
};
